export default {
  messageType: 'Basic type',
  label: {
    imageLink: 'Image Link',
    image: 'Attach Image',
  },
  placeholder: {
    imageLink: 'http://',
    content: 'Please enter the message content.',
    brandTextContent: '1,300 characters',
    textContent: '1,000 characters',
    imageContent: '400 characters',
    wideImageContent: '76 characters',
  },
  comment: {
    image: '※ Sent as either a standard or wide image format.',
    imageLink: '※ Enter the URL to be linked when tapping the attached image.',
  },
  preview: {
    header: 'Advertising',
    footer: 'To unsubscribe : Home > Block a Channel',
    content: 'Please enter the contents.',
    title: 'Please enter the title.',
    productName: 'Please enter the product name.',
    regularPrice: 'Regular Price',
    discountPrice: 'Discount Price',
    discountRate: 'Discount Rate',
    discountFixed: 'Fixed Discount Price',
    KRW: 'Won',
    additionalContent: 'Please enter additional information.',
    intro: 'Enabled when the carousel intro setting is used.',
    introTitle: 'Please enter the intro title.',
    introContent: 'Please enter the intro content.',
    tail: 'More view',
  },
};
